<template>
  <div class="cart-index" :class="{'reserve-index': orderinfo.dining_mode==3 && orderinfo.rtype == 1}">
    <Loading v-if="!requested" />

    <v-overlay :value="isFind" z-index="2000" v-if="isFind">
      <find-driver @close-overlay="closeOverlay" @cancel="cancelDelivery" :location="location" :orderInfo="orderinfo" :orderRes="orderRes" :deliveryStatus="deliveryStatus" />
    </v-overlay>

    <ChoosePayMethod v-if="isPayMethod"
    :confirm="paynow"
    :cancel="cancelPayMethod"
    :store="this.store"
    :payMethod="this.payMethod" />

    <TopNavbar :title="'My Orders'" :bgColor="'bg-main'">
      <div class="order-detail-navbar">
        <div class="home-logo" @click="addOrder"><img :src="homelogo" /></div>
        <div class="title onHome" @click="()=>overlay=true">My Order</div>
      </div>
    </TopNavbar>
    <div class="is-empty" v-if="requested && isEmpty">This order doesn't exist</div>

    <div v-if="requested && !isEmpty" class="main" :class="{'no-product': orderinfo.dining_mode==3 && orderinfo.rtype == 1}">
      <div class="order-store-name flex flex-center">
        <div class="store-logo"><img :src="storeinfo.logo" /></div>
        <div class="store-name">{{ storeinfo.title }}</div>
      </div>
      <TablesInfo :tablesInfo="tableData" />
      
      <StoreInfo :key="StoreInfoKey" v-if="order_status == -1" :orderStatus="1" :stepsList="['pending', 'Cancelled']" />

      <StoreInfo :key="StoreInfoKey" v-if="order_status != -1 && orderinfo.dining_mode == 2" :isAccept="isAccept" :orderStatus="order_status" :orderInfo="orderinfo" :stepsList="['pending', 'accepted', 'ongoing', 'completed']" />

      <StoreInfo :key="StoreInfoKey" v-if="(order_status != -1 && orderinfo.dining_mode == 1) || (order_status != -1 && orderinfo.dining_mode == 3)" :orderStatus="order_status" :orderInfo="orderinfo" :stepsList="['pending', 'confirmed', 'completed']" />

      <div class="order-summary">Order Summary</div>
      <div class="order-wapper">
        <div class="flex rowx justify-between">
          <div>Order No.</div>
          <div>{{ orderinfo.ordersn }}</div>
        </div>
        <div class="flex rowx justify-between" v-if="!(orderinfo.dining_mode==3 && orderinfo.rtype == 1)">
          <div>Payment Type</div>
          <div>{{ paymentType }}</div>
        </div>

        <div class="flex rowx justify-between" v-if="!(orderinfo.dining_mode==3 && orderinfo.rtype == 1)">
          <div>Payment Status</div>
          <div>{{ PaymentStatus }}</div>
        </div>

        <div class="flex rowx justify-between" v-if="Object.keys(contact).length">
          <div>Contact Info</div>
          <div>{{ contact.receiver_name }} <span v-if="contact.receiver_phone">({{ contact.receiver_phone }})</span></div>
        </div>

        <div class="flex rowx justify-between" v-if="orderDatetime">
          <div>Order Date</div>
          <div>{{ orderDatetime }}</div>
        </div>

        <div class="flex rowx justify-between" v-if="reservationTime">
          <div>Reservation Time</div>
          <div>{{ reservationTime }}</div>
        </div>

        <div class="flex rowx justify-between" v-if="orderinfo.dining_mode!=3 && orderinfo.schedule_type==1">
          <div>Pick-up Date</div>
          <div>{{ orderinfo.schedule_datetime }}</div>
        </div>

        <div class="flex rowx justify-between">
          <div>Remark</div>
          <div v-if="orderinfo.remark == ''">-</div>
          <div v-if="orderinfo.remark != ''">{{ orderinfo.remark }}</div>
        </div>
      </div>
      
      <div class="user-info" v-if="table.is_takeaway == true || table.is_delivery == true || orderinfo.dining_mode == 3">User Info</div>
      <div class="delivery-wapper">
        <div class="rowx" v-if="orderinfo.receiver_name != ''">
          <div><van-icon style="vertical-align:text-bottom;" size="16px" name="user-o"/> {{ orderinfo.receiver_name }}</div>
        </div>
        
        <div class="rowx" v-if="orderinfo.receiver_phone != ''">
          <div><van-icon style="vertical-align:text-bottom;" size="16px" name="phone-o"/> {{ orderinfo.receiver_phone }}</div>
        </div>

        <div class="rowx" v-if="orderinfo.email != ''">
          <div><van-icon style="vertical-align:text-bottom;" size="16px" name="envelop-o"/> {{ orderinfo.email }}</div>
        </div>
        <div class="rowx" v-if="orderinfo.address != ''">
          <div><van-icon style="vertical-align:text-bottom;" size="16px" name="location-o"/> {{ orderinfo.address }}</div>
        </div>
      </div>

      <div class="order-item-list">&nbsp;</div>

      <div class="product-list" v-if="!(orderinfo.dining_mode==3 && orderinfo.rtype == 1)">
        <div class="list-header bg-main flex flex-start justify-between">
          <div class="item-name">Item Name</div>
          <div class="item-qty">Qty.</div>
          <div class="item-price">Price</div>
        </div>

        <div class="list-items flex flex-start justify-between flex1" v-for="(item, index) in productList" :key="index" :class="{'line-top':index}">
          <div class="item-name">
            <div class="w600">{{item.name}}</div>
            <div v-if="item.sku" class="item-sku">SKU: {{item.sku}}</div>
            <div v-if="item.tags.length">
              <Tags v-for="(tagName, tagId) in item.tags" :key="tagId" :text="tagName" />
            </div>
          </div>
          <div class="item-qty">{{item.qty}}</div>
          <div class="item-price">RM {{ fmPrice(parseFloat(item.price) * parseInt(item.qty)) }}</div>
        </div>

      </div>

    </div>
    <div class="footer bg-main" v-if="requested && !(orderinfo.dining_mode==3 && orderinfo.rtype == 1) ">
      <div class="flex justify-between pre-summary">
        <div class="flex1"></div>
        <div class="summary">
          <div v-for="(item, index) in cart.summmary" :key="index">
            <div class="row flex justify-end">
              <div class="label">{{item.label}}</div>
              <div class="colons">:</div>
              <div class="currency" v-if="item.type!=='totalitem'">RM</div>
              <div class="currency" v-if="item.type=='totalitem'"></div>
              <div class="text" v-if="item.type!=='totalitem'">{{ fmPrice(item.text) }}</div>
              <div class="text" v-if="item.type==='totalitem'">{{ item.text }}</div>
            </div>
          </div>

          <div class="row flex justify-end total-amount">
            <div class="label">Total Amount</div>
            <div class="colons">:</div>
            <div class="currency">RM</div>
            <div class="text">{{ totalAmount }}</div>
          </div>
        </div>
      </div>
      <div class="footer-btn-container">
        <div class="flex flex-center">
          <div class="flex1 add-order" v-if="!(orderinfo['dining_mode'] == 1 && orderinfo['is_takeaway'] == 0 && storeinfo.pos_status == 1)" @click="addOrder">New Order</div>
          <div v-if="orderinfo.dining_mode==2 && lalamove_order.delivery_status && parseInt(lalamove_order.delivery_status)==3 && orderinfo.isreceived==0" class="flex1 confirm-delivery" @click="confirmDelivery">Confirm Delivered</div>
          <div v-if="orderinfo.is_takeaway==1 && orderinfo.status==1 && orderinfo.isreceived==0" class="flex1 confirm-delivery" @click="collectedTakeaway">Collected</div>
          <div v-if="storeinfo.glypay==1 && (((orderinfo.dining_mode==1 || (orderinfo.dining_mode==3 && orderinfo.rtype == 2)) && orderinfo.is_takeaway==0 && storeinfo.glypay_payment_type.dinein==1) || (orderinfo.dining_mode==1 && orderinfo.is_takeaway==1 && storeinfo.glypay_payment_type.takeaway==1) || (orderinfo.dining_mode==2 && storeinfo.glypay_payment_type.delivery==1)) && orderinfo.status==0 && orderinfo.ispay==0 || (orderinfo.is_append == 1 && PaymentStatus.includes('Partially Paid'))" class="flex1 confirm-delivery" @click="checkOrder">Pay Now</div>
          <!-- <div v-if="orderinfo.dining_mode==2 && lalamove_order.delivery_status && parseInt(lalamove_order.delivery_status)==0" class="flex1 confirm-delivery" @click="cancelDelivery">Cancel Order</div> -->
        </div>
      </div>
    </div>

    <a :href="this.track_url" target="_blank" class="icon_delivery" v-if="this.track_url">
      <p>Tracking</p>
      <img :src="icon_delivery" />
    </a>
    
    <!--
    <div class="icon_delivery" v-if="orderinfo.dining_mode==2 && lalamove_order.delivery_status && parseInt(lalamove_order.delivery_status)>=1" @click="orderDelivery">
      <img :src="icon_delivery" />
    </div>
    -->
  </div>
</template>
<script>
import TopNavbar from '../../components/common/TopNavbar.vue'
import StoreInfo from '../../components/common/StoreInfo.vue'
import Tags from '../../components/common/Tags.vue'
import ChoosePayMethod from '../../components/common/ChoosePayMethod.vue'
import { Toast } from 'vant';
import { isNumber } from 'util';
import TablesInfo from '../../components/common/TablesInfo.vue'
import Loading from '@/components/common/Loading.vue'
import { getDeliveryQuotation,getOrderDetail, updateDeliveryOrder, getDeliveryProcessInfo, makeOrderPayment, updateTakeawayOrder } from '@/api/api'
import homelogo from "@/assets/logo.png"
import deliveryIcon from "@/assets/delivery.gif"
import { cartMixin } from '@/mixins/cartMixin'
import mockDemo from '@/api/mock2'
import mockDelivery from '@/api/mockDeliveryInfo'
import FindDriver from '../track/index.vue'
import { getApiFindDriver } from '@/api/api2'

export default {
  components: {
    TopNavbar, 
    StoreInfo, 
    Tags, 
    TablesInfo, 
    Loading,
    FindDriver,
    ChoosePayMethod
  },
  props: {
  },
  data() {
    return {
      resInf : {},
      orderRes: {},
      deliveryStatus: 0,
      location: {},
      currentDate: false,
      isFind:false,
      totalAmount: 0.0,
      indexPage: {},
      isDev: false,
      requested: false,
      homelogo: homelogo,
      icon_delivery: deliveryIcon,
      isEmpty: false,
      storeinfo: {},
      orderinfo: {},
      lalamove_order: {}, //lalamove的订单信息
      goodslist: {},
      table: {},
      tablezones: {},
      tableData: {},
      pay_payment: [],
      service_money: 0,
      totalnum: 0,
      paymentType: '',
      PaymentStatus: '',
      order_status: 0, //订单状态
      delivery_status: 0,
      StoreInfoKey: + new Date(),
      contact: {},
      orderDatetime: '',
      reservationTime: '',
      cart: {
        summmary: []
      },
      productList: [],

      isCoupon: false,
      isPayMethod: false,
      payMethod: {},
      coupon_code: '',
      order_remark: '',
      orderid: 0,
      isAccept: 0,
      isRequestedDelivery: true, // 自动刷新 delivery 的请求是否已结束
      isRefreshDelivery: true,  // 是否自动刷新delivery状态数据
      track_url: ''
    }
  },
  created() {
    // const isDev = process.env.NODE_ENV === 'development'
    this.initPageData()
  },
  computed: {
  },
	watch:{
		isFind: {
			handler(val, oldVal){
				if(this.isFind){
          document.getElementsByTagName('html')[0].style.overflow = "hidden";
        }else{
          document.getElementsByTagName('html')[0].removeAttribute("style");
        }
			}
		}
	},
  mixins: [cartMixin],
  methods: {
    closeOverlay(){
      this.isFind=false
    },

    async quotation() {
        console.log('quotation delivery option',this.deliveryOption)
        console.log('quotation schedule type',this.order.schedule.type)
        console.log('quotation schedule time',this.order.schedule.datetime)
        console.log('quotation delivery storeinfo',this.delivery_current_storeinfo)

        const queryParams = { i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_delivery_quotation' }
        const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
        getDeliveryQuotation('/app/index.php?' + suffixQuery, {serviceType:this.deliveryOption, store: this.delivery_current_storeinfo, dish_datetime: this.order.schedule.datetime, schedule_type: this.order.schedule.type }).then(res => {
            this.isRequest = true
            if (res.status == false) {
            this.$toast(res.msg)
            } else {
            if(res.data) {
                console.log('res data',res.data)
            }
            }
        }).catch(error => {
            this.isRequest = true
            console.log('.............quotation.......error', error);
        })
    },
    fmPrice(str_val) {
      return parseFloat(str_val).toFixed(2)
    },
    getRouteQuery() {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'orderdetail'
      return tempParams
    },
    initPageData() {
      //development
      // if(process.env.NODE_ENV === 'development'){
      //   console.log('isDev')
      //     this.indexPage = mockDemo.indexPage
      //     console.log('indexpage',this.indexPage)
      //     this.todoOrder(this.indexPage)
      //     this.requested = true
      //     this.isEmpty = false
      // }

      //production
      getOrderDetail('/app/index.php', this.getRouteQuery()).then(res => {
        this.todoOrder(res)
      
        this.requested = true
        this.isEmpty = false
      }).catch((error) => {
        // console.log('获取订单详情====>error', error)
        this.requested = true
        this.isEmpty = true
      })
    },
    todoOrder(apiRes) {
      //处理订单信息
      const { data } = apiRes
      console.log('data>>>', data);
      this.resInf = apiRes
      this.order_status = parseInt(data.orderinfo.status)
      this.goodslist = data.goodslist
      this.orderinfo = data.orderinfo
      this.isAccept = parseInt(data.orderinfo.isaccept);
      console.log('orderInfo>>>', this.orderinfo);
      this.orderid = data.orderinfo.id || 0
      this.lalamove_order = data.lalamove || {}
      this.storeinfo = data.store
      this.table = data.table
      this.tablezones = data.tablezones
      this.tableData = {
        title: data.table.title,
        tel: data.store.tel,
        table: data.table,
        tablezones: data.tablezones,
        promo: data.store.promo || '',
      }
      this.pay_payment = data.store.pay_payment.split(",")
      this.PaymentStatus = data.orderinfo.payment_status_label
      this.cart.summmary = data.summmary
      this.payMethod = data.payMethod || {}
      this.service_money = data.orderinfo.service_sst || 0
      this.contact = data.contact
      this.orderDatetime = data.orderinfo.orderDatetime
      let orderDateTime1 = new Date(this.orderDatetime);
      let curDateTime = new Date();
      let curDate = curDateTime.toISOString().slice(0,10);
      if (data.orderinfo.dining_mode == 3){
          this.reservationTime = data.orderinfo.reservationTime
          let reserveTime = new Date(this.reservationTime);
          let reserveDate = reserveTime.toISOString().slice(0,10);
          console.log('Current Date', curDate, ' , Reservation Date', reserveDate);
          if (reserveDate == curDate){
            this.currentDate = true;
          } else {
            this.currentDate = false;
          }
      }
      this.totalnum = data.orderinfo.totalnum
      this.totalAmount = this.fmPrice(data.orderinfo.totalAmount)
      if (data.table.is_delivery) {
        //判断是否是 delivery 类型订单， 并每15秒自动更新状态
        this.initDeliveryData()

        this.findDriver()
      }
      const todoPaymentType = () => {
        let paytype = data.orderinfo.paytype
        this.paymentType = this.pay_payment[paytype]
      }
      const todoGoodsList = () => {
        this.productList = this.goodslist && this.goodslist.map(item => {
          return {
            sku: item.id,
            qty: item.total,
            price: item.price,
            name: item.title,
            tags: item.optionname.split(","),
          }
        }, [])
      }
      todoPaymentType && todoPaymentType()
      todoGoodsList && todoGoodsList()
      console.log('payment status',this.PaymentStatus)
      if(this.PaymentStatus == 'Unpaid'){
        //
      }
    },
    addOrder() {
      let queryParams = {
        i: 2,
        c: 'entry',
        do: 'waplist',
        m: 'weisrc_dish',
        mode: parseInt(this.orderinfo['dining_mode']),
        storeid: parseInt(this.orderinfo['storeid']),
        append: 1,
      }
      if (this.orderinfo['dining_mode'] == 1 && this.orderinfo['is_takeaway'] == 0 && this.storeinfo.pos_status == 1){
        return false
      }
      if (parseInt(this.orderinfo['dining_mode']) === 1) {
        queryParams.tablesid = this.orderinfo.tables
      }
      if (this.table.scene_code && this.table.yours_url) {
        if (this.table.scene_code != '' && this.table.yours_url != '') {
          queryParams.scene_code = this.table.scene_code
        }
      }
      const url = { path: '/', query: queryParams }
      console.log('去到首页-点餐页面', url);
      this.$router.push(url)
    },
    checkOrder(){
        getOrderDetail('/app/index.php', this.getRouteQuery()).then(res => {
          this.todoOrder(res)
          this.requested = true
          this.isEmpty = false
          if (this.order_status == -1){
              this.$toast('This order was already cancelled! Cannot make a payment now');
          } else {
              this.choosePayMethod();
          }
        }).catch((error) => {
          // console.log('获取订单详情====>error', error)
          this.requested = true
          this.isEmpty = true
        })
    },
    choosePayMethod(){
        if (this.payMethod.is_redirect == 0){
            this.paynow();
        } else {
            this.isPayMethod = true;
        }
        console.log('this payment method => ',this.payMethod,', isPayMethod => ',this.isPayMethod)
    },
    paynow() {
      let loader = this.$loading.show({
        container: null
      });

      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'paynow' })
      const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
      makeOrderPayment('/app/index.php?' + suffixQuery, { ordersn: this.orderinfo.ordersn, storeid: this.orderinfo.storeid, payChannel: this.payMethod.choosedChannel })
      .then(res => {
        console.log('...................makeOrderPayment#res', res);

        if (res.type == 'ajax' || res.type == 'json') {
          const checkoutUrl = (res.redirect != '' && res.message == '') ? res.redirect : res.data.checkoutUrl
          if (res.status && parseInt(res.code) == 200) {
            window.location.href = checkoutUrl
          } else {
            this.$toast(res.msg)
          }
          
          this.requested = true
        } else {
          this.$toast('Unable to redirect to GLYPay');
          this.requested = true
        }
      })
      .catch(error => {
        this.$toast('Internal server error with GLYPay')
        this.requested = true
      }).finally(()=>{ 
        loader.hide();
      });
    },
    cancelPayMethod() {
        this.isPayMethod = false;
    },
    confirmDelivery() {
      if (confirm('Confirm the order is delivered?')){
        const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'update_delivery_order' })
        const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
        updateDeliveryOrder('/app/index.php?' + suffixQuery, { ordersn: this.orderinfo.ordersn, storeid: this.orderinfo.storeid, orderref: this.lalamove_order.orderRef || '' })
          .then(res => {
            if (res.status && parseInt(res.code) === 200) {
              window.location.reload()
            } else {
              this.current_address_id = 0
              this.$toast(res.msg)
            }
            this.requested = true
          })
          .catch(error => {
            this.$toast('network time!')
            this.requested = true
          })
      }
    },
    collectedTakeaway() {
      if (confirm('Confirm the order is collected?')){
        const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'update_takeaway_order' })
        const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
        updateTakeawayOrder('/app/index.php?' + suffixQuery, { ordersn: this.orderinfo.ordersn, storeid: this.orderinfo.storeid})
          .then(res => {
            if (res.status && parseInt(res.code) === 200) {
              window.location.reload()
            } else {
              this.current_address_id = 0
              this.$toast(res.msg)
            }
            this.requested = true
          })
          .catch(error => {
            this.$toast('network time!')
            this.requested = true
          })
      }
    },
    cancelDelivery(){
      console.log('..cancelDelivery')
      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'cancel_delivery_order' })
      const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
      updateDeliveryOrder('/app/index.php?' + suffixQuery, { ordersn: this.orderinfo.ordersn, storeid: this.orderinfo.storeid, orderref: this.lalamove_order.orderRef || '' })
        .then(res => {
          if (res.status && parseInt(res.code) === 200) {
            console.log('updateDeliveryOrder.res........', res);
            this.$toast(res.msg)
            this.isFind = false
            // window.location.reload()
          } else {
            this.current_address_id = 0
            this.$toast(res.msg)
          }
          this.requested = true
        })
        .catch(error => {
          this.$toast('network time!')
          this.requested = true
        })
    },
    orderDelivery() {
      //打开骑手订单详情信息页面
      let queryParams = {
        orderid: parseInt(this.orderinfo['id']),
      }
      const url = { path: '/order/driverArrived', query: queryParams }
      this.$router.push(url)
    },
    // refresh delivery -------------------------------------------------------------
    initDeliveryStatus() {
      if (this.isRequestedDelivery && this.isRefreshDelivery) {
        setTimeout(() => {
          this.isRequestedDelivery = false
          this.initDeliveryData()

          this.findDriver()
        }, 5000);
      }
    },
    initDeliveryData() {
      let queryParams = { i: 2, c: 'entry', do: 'delivery_order_processing', m: 'weisrc_dish', orderid: parseInt(this.orderid), append: 1, }
      getDeliveryProcessInfo('/app/index.php', queryParams).then(res => {
        console.log('.......................getDeliveryProcessInfozzz', res);
        this.isRequestedDelivery = true
        this.isRefreshDelivery = res.data.isRefresh
        this.lalamove_order.delivery_status = res.data.delivery_status
        this.StoreInfoKey = + +(new Date())
        this.order_status = res.data.order_status || 0
        this.track_url = res.data.redirectUrl;
        console.log('this.order_status>>>', this.order_status)
        this.initDeliveryStatus()

      }).catch((error) => {
        this.StoreInfoKey = + +(new Date())
        console.log('.......................error', error)
        this.isRequestedDelivery = true
        this.initDeliveryStatus()
      })
    },
    // refresh delivery -------------------------------------------------------------

    findDriver(){
      console.log('.........getDeliveryInfo')
      const { data } = this.resInf
      if(data.store.is_assign_driver == '1' && data.orderinfo.dining_mode == 2 && this.order_status != -1 ){
          if(data.table.is_delivery && data.orderinfo.schedule_type == 0 && data.orderinfo.ispay == 1 ){
            this.location = { customer : { position: { lat: parseFloat(data.orderinfo.lat), lng: parseFloat(data.orderinfo.lng )}}}
            this.fetchDeliveryInfo();
        }
      }
    },
    fetchDeliveryInfo(){
      console.log('.........fetchDeliveryInfo')
      //development
      // if(process.env.NODE_ENV === 'development'){
      //   console.log('isDev')
      //     console.log('res...get delivery info',mockDelivery.indexPage)
      //     const { data } = mockDelivery.indexPage
      //     this.orderRes = mockDelivery.indexPage
          
      //     if(data.delivery != undefined || data.delivery != null ){
      //         let deliveryInfo = data.delivery
      //         this.deliveryStatus = data.delivery.status
      //         if(deliveryInfo.status == 0 || deliveryInfo.status == 5){
      //           this.isFind = true
      //         }else {
      //           this.isFind = false
      //         }
      //     }
      // }
      
      // production
      getApiFindDriver(`/fomy/v2/store/${this.orderinfo.storeid}/order/${this.orderinfo.id}`)
        .then(res => {
          console.log('res...get delivery info',res)
          const { data } = res
          this.orderRes = res
          if(data.delivery != undefined || data.delivery != null ){
              let deliveryInfo = data.delivery
              if(deliveryInfo.status == 0 || deliveryInfo.status == 5){
                this.isFind = true
              }else {
                this.isFind = false
              }
          }
        }).catch((error) => {
          console.error('Error:', error);
        });
    },

  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.title {
  font-weight: 700;
}
.order-detail-navbar {
  width: 100%;
  display: flex;
  align-items: center;
  .home-logo {
    width: 20px;
    height: 20px;
    img {
      width: 100%;
    }
  }
}
.onHome {
  padding: 4px 0;
  flex: 1;
  text-align: center;
}

.is-empty {
  padding: 5px;
  color: #666;
}
.reserve-index {
  margin: 36px 0 0 0 !important;
}
.cart-index {
  text-align: left;
  margin: 36px 0 40px 0;
  .no-product{
    padding: 0 !important;
  }
  .main {
    background-color: @fff;
    // padding: 0 0 150px 0;
    padding: 0 0 250px 0;
    .order-store-name {
      padding: 12px 5px 0px 5px;
      font-size: 18px;
      .store-logo {
        margin-right: 10px;
        img {
          width: 40px;
          height: 40px;
          object-fit: fill;
          border-radius: 50%;
        }
      }
    }
    .order-summary {
      margin: 10px 0 0 0;
      background-color: #eeeeee;
      padding: 12px 8px 5px 5px;
      font-size: 16px;
    }
    .user-info {
      margin: 10px 0 0 0;
      background-color: #eeeeee;
      padding: 12px 8px 5px 5px;
      font-size: 16px;
    }
    .delivery-wapper {
      padding: 8px;
      font-size: @size12;
      line-height: 16px;
      .rowx {
        margin: 6px 0;
      }
    }
    .order-item-list {
      background-color: #eeeeee;
      padding: 3px;
      font-size: 16px;
    }
    .order-wapper {
      padding: 8px;
      font-size: @size12;
      .rowx {
        margin: 6px 0;
      }
    }
    //顶部内容
    .tables-room {
      padding: 5px;
      font-size: @size14;
      .row {
        margin: 5px 0;
        .label {
          flex-basis: 120px;
        }
        .colons {
          font-weight: 700;
          padding: 0 3px;
        }
        .text {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    //菜单列表
    .product-list {
      .item-name {
        flex: 1;
      }
      .item-sku{
        font-size: 10px;
        color: #aaa;
        margin-bottom: 6px;
      }
      .item-qty {
        flex-basis: 30px;
        text-align: center;
      }
      .item-price {
        flex-basis: 60px;
        text-align: right;
      }
      .list-header {
        padding: 5px;
      }
      .list-items {
        margin: 5px 0;
        padding: 5px;
        font-size: @size14;
        .item-image {
          flex-basis: 100px;
          margin: 0 8px 0 0;
          img {
            width: 100%;
            max-width: 100px;
            max-height: 75px;
            border-radius: 5px;
          }
        }
      }
      .line-top {
        border-top: 1px solid rgba(0, 0, 0, 0.06);
      }
    }
  }
  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: @size14;
    text-align: center;
    box-shadow: 0px 17px 20px 10px rgba(146, 146, 146, 0.85),
      -10px 10px 10px 10px rgba(255, 255, 255, 0.5);

    .pre-summary {
      background-color: #ffffff;
      padding: 18px 8px 18px 8px;

      .summary {
        font-size: @size14;
        color: #2c3e50;
        flex-basis: 400px;
        .colons {
          font-weight: 700;
          padding: 0 3px;
        }
        .currency {
          padding: 0 3px;
          flex-basis: 30px;
        }
        .text {
          flex-basis: 50px;
          text-align: right;
          font-size: @size14;
        }

        .total-amount {
          border-top: 1px solid #eee;
          padding-top: 3px;
          margin-top: 3px;
          font-weight: bold;
        }
      }
    }

    .place-order {
      padding: 10px 8px;
      .colons {
        border-left: 1px solid rgba(255, 255, 255, 0.8);
        flex-basis: 1px;
        height: 10px;
      }
    }

    .footer-btn-container {
      .add-order {
        background-color: @main;
        padding: 13px 0;
        text-align: center;
        font-weight: bold;
      }
      .confirm-delivery {
        background-color: @main;
        padding: 13px 0;
        border-left: 1px solid #ffffff;
        text-align: center;
        font-weight: bold;
      }
    }
  }

  .icon_delivery {
    z-index: 1003;
    position: fixed;
    bottom: 60px;
    left: 30px;
    width: 50px;
    text-align: center;
    > p {
      font-size: 12px;
      font-weight: bolder;
      color: black;
    }
    > img {
      width: 100%;
      background: white;
      border: 1p solid @red;
      box-shadow: 0px 1px 16px #ffb7a0;
      border-radius: 50%;
      animation: glowing 1300ms infinite;
    }
  }

  @keyframes glowing {
    0% {
      box-shadow: 0 0 5px #ee2d24;
    }
    50% {
      box-shadow: 0 0 20px #ee2d24;
    }
    100% {
      box-shadow: 0 0 5px #ee2d24;
    }
  }
}
</style>

